// Document link
export const URL = {
  PricingPlanBilling:
    'https://support.boostcommerce.net/en/collections/9437018-pricing-plans-billing',
  ShopifyInventory: 'https://help.shopify.com/en/manual/products/inventory',
  ShopifyStoreReviewLink:
    'https://apps.shopify.com/product-filter-search#modal-show=WriteReviewModal',
  CaseStudies:
    'https://blog.boostcommerce.net/posts/how-boost-commerce-helped-urban-sales-improve-the-sitewide-conversion-rate-by-14',
  CaseStudyOkanui:
    'https://blog.boostcommerce.net/posts/how-okanui-achieved-a-29-conversion-rate-and-30-aov-lift',
  // Header doc
  UpgradeNewVersion:
    'https://help.boostcommerce.net/article/887-upgrading-to-the-new-version-of-search-and-merchandising',
  SearchSettingsDoc: 'https://help.boostcommerce.net/category/591-search-search-overall',
  SearchSettingsDocV2:
    'https://support.boostcommerce.net/en/articles/9359406-the-algorithm-of-search-relevance ',
  SuggestionDictionaryDoc:
    'https://help.boostcommerce.net/article/309-how-to-change-the-orders-of-popular-suggestions-using-suggestion-dictionary',
  SuggestionDictionaryDocV2:
    'https://support.boostcommerce.net/en/articles/9360394-custom-ranking-of-popular-suggestions-returned-by-autocomplete-search#h2',
  RedirectsDoc: 'https://help.boostcommerce.net/article/315-how-to-use-redirect',
  ISWDoc: 'https://support.boostcommerce.net/en/articles/9360392-instant-search-widget',
  InstantSearchDisplayDoc:
    'https://help.boostcommerce.net/category/592-search-instant-search-display',
  IntegrationDoc:
    'https://support.boostcommerce.net/en/collections/9461876-third-party-app-integration',
  TranslationDoc: 'https://help.boostcommerce.net/category/634-tool-translation',
  MergeValues: 'https://help.boostcommerce.net/article/299-how-to-merge-values',
  StopWordsDoc: 'https://help.boostcommerce.net/article/410-how-to-use-stop-words',
  ProductVisibilityDoc: 'https://help.boostcommerce.net/article/459-how-to-use-product-visibility',
  SwatchSettingsDoc:
    'https://help.boostcommerce.net/article/494-how-to-display-swatches-in-a-filter-option-using-swatch-settings',
  GeneralSwatchDoc:
    'https://support.boostcommerce.net/en/articles/9355701-displaying-swatches-in-your-filter-tree',
  CustomSortingDoc: 'https://support.boostcommerce.net/en/collections/9468782-sort-by-options',
  ManageFilterTreesDoc:
    'https://help.boostcommerce.net/category/627-filter-manage-filter-trees-create-and-manage-filter-trees',
  DisplaySettingsDoc:
    'https://help.boostcommerce.net/category/628-filter-filter-settings-display-settings',
  ThemeSetupDoc:
    'https://support.boostcommerce.net/en/collections/9468770-theme-setup-for-turbo-version',
  ThemeSetupDoc_01:
    'https://help.boostcommerce.net/article/343-how-to-set-up-the-app-on-a-certain-theme',
  ThemeSetupDoc_02: 'https://help.boostcommerce.net/article/727-how-to-revert-theme-setup',
  ThemeSetupDoc_03: 'https://help.boostcommerce.net/article/342-supported-theme',
  ThemeSetupDoc_04: 'https://help.boostcommerce.net/article/337-default-theme',
  ThemeSetupDoc_SuccessLink:
    'https://boostcommerce.net/blogs/all/tagged/case-studies?utm_source=PFS+App&utm_medium=Theme+revert+feedback&utm_campaign=Theme+revert+feedback',
  ThemeRevertDoc: 'https://help.boostcommerce.net/category/643-theme-setup-theme-revert',
  ThemeRevertManualInstruction:
    'https://help.boostcommerce.net/article/727-how-to-revert-theme-setup#new1',
  SwitchFilterLayoutDoc: 'https://help.boostcommerce.net/article/344-how-to-change-filter-layout',
  DefaultLayoutSettingsDoc: 'https://help.boostcommerce.net/article/345-default-layout-settings',
  QuickViewCartSettingsDoc:
    'https://help.boostcommerce.net/article/736-how-to-use-quick-view-cart-settings',
  LanguageSettingsDoc:
    'https://support.boostcommerce.net/en/articles/9393631-how-to-change-language-in-boost-ai-search-discovery',
  SubscriptionDoc: 'https://help.boostcommerce.net/article/424-how-to-subscribe',
  DefaultThemeSettingsDoc:
    'https://help.boostcommerce.net/article/737-how-to-use-the-default-theme-settings',
  FilterLayoutDoc:
    'https://support.boostcommerce.net/en/articles/9355715-to-customize-your-filter-layout',
  DisplaySettings:
    'https://support.boostcommerce.net/en/articles/9359368-how-to-customize-the-display-of-your-filter-trees-and-product-list',
  CommerceSearch:
    'https://support.boostcommerce.net/en/articles/9362109-merchandising-rules-for-commerce-search',
  CollectionRules:
    'https://support.boostcommerce.net/en/articles/9362101-merchandising-rules-for-collection-page',
  // Doc content
  UpdateMenu:
    'https://help.boostcommerce.net/article/945-new-interface-of-boost-ai-search-discovery',
  ReviewIO: 'https://reviews.io/',
  ReviewIOSubscriptionPage: 'https://dash.reviews.io/subscription',
  KnowledgeBase1_01: 'https://www.youtube.com/embed/-mh3vXjGziI',
  KnowledgeBase1_02: 'https://www.youtube.com/embed/M6g5ufDjJls',
  KnowledgeBase1_03: 'https://www.youtube.com/embed/Jfqc45msJbE',
  KnowledgeBase2_01: 'https://boostcommerce.net/blogs/all/digital-merchandising-feature-of-boost',
  KnowledgeBase2_02: 'https://help.boostcommerce.net/article/413-how-to-use-analytics',
  KnowledgeBase2_03: 'https://help.boostcommerce.net/article/336-theme-setup',
  NewLanguageNotification:
    'https://boostcommerce.net/blogs/all/boost-product-filter-search-in-shopify-germany?utm_source=BoostPFS&utm_medium=in-app%20noti&utm_campaign=Market%20Development%20-%20Germany%20launch%202021',
  FilterVerticalDemo: 'https://boost-pfs-demo.myshopify.com/collections/vertical-layout',
  FilterHorizontalDemo: 'https://boost-pfs-demo.myshopify.com/collections/horizontal-layout',
  ThemeDemo: 'https://boost-pfs-demo.myshopify.com',
  SubscriptionPlanDoc:
    'https://support.boostcommerce.net/en/articles/9334587-pricing-plan-overview#h_ad2ce1c7d9',
  SubscriptionV5PlanDoc:
    'https://support.boostcommerce.net/en/collections/15873387-gmv-pricing-plan',
  SubscriptionV5PlanManageGMV:
    'https://support.boostcommerce.net/en/articles/12545678-manage-your-gmv-based-subscription#h_1a38d3e816',
  SubscriptionV5PlanGMVOverview:
    'https://support.boostcommerce.net/en/articles/12545618-gmv-based-pricing-plan-overview#h_f4ff221559',
  SubscriptionV5MigrationGuide: 'https://boostcommerce.net/platform/pricing',
  SubscriptionPriceIncreaseLearnWhy:
    'https://support.boostcommerce.net/en/articles/15322463-understanding-boost-s-legacy-plans-and-pricing-evolution',
  DuplicatingThemesDoc:
    'https://help.shopify.com/en/manual/online-store/themes/managing-themes/duplicating-themes',
  ManualSetupV1:
    'https://support.boostcommerce.net/en/articles/9362387-setting-up-the-app-on-an-os-2-0-theme-with-theme-app-extension',
  ManualSetupV2:
    'https://support.boostcommerce.net/en/articles/9362387-setting-up-the-app-on-an-os-2-0-theme-with-theme-app-extension',
  EnableAppBlockTAE:
    'https://help.boostcommerce.net/article/679-how-to-enable-app-blocks-in-theme-app-extension',
  ManualSetupV3:
    'https://support.boostcommerce.net/en/articles/9362387-setting-up-the-app-on-an-os-2-0-theme-with-theme-app-extension',
  ThemeSetupV3Doc_use:
    'https://support.boostcommerce.net/en/articles/9362387-setting-up-the-app-on-an-os-2-0-theme-with-theme-app-extension',
  ThemeSetupV3Doc_revert:
    'https://help.boostcommerce.net/article/844-removing-the-apps-features-from-a-theme-with-theme-app-extension',
  ThemeSetupV3Doc_list_support: 'https://help.boostcommerce.net/article/342-supported-theme',
  ThemeSetupV3Doc_default_layout: 'https://help.boostcommerce.net/article/337-default-theme',
  ThemeSetupV3Doc_learn_more:
    'https://support.boostcommerce.net/en/articles/9362387-setting-up-the-app-on-an-os-2-0-theme-with-theme-app-extension',
  ThemeSetupV3Doc_shopify_guide:
    'https://help.shopify.com/en/manual/online-store/themes/managing-themes/upgrading-themes',
  ThemeSetupV3Doc_FAQ: 'https://support.boostcommerce.net/en/articles/9393591-themes-faqs',
  ThemSetupFAQ: 'https://support.boostcommerce.net/en/collections/9468524-theme-setup',
  ShopifyThemes: 'https://themes.shopify.com/',
  MergeValuesDoc:
    'https://boostcommerce.helpscoutdocs.com/article/152-how-to-merge-values-light-blue-and-dark-blue-to-blue',
  Review: 'https://apps.shopify.com/product-filter-search#reviews',
  HelpCenter: 'https://help.boostcommerce.net/',
  HelpCenterOS2:
    'https://support.boostcommerce.net/en/articles/9362199-for-dev-how-to-set-up-recommendation-feature-manually-for-theme-os-1-0',
  HelpCenterOS1:
    'https://help.boostcommerce.net/article/882-how-to-setup-recommendation-feature-manually-for-os-2-0-os-1-0#Method-2-Inserting-our-manual-code-into-the-special-position-IEdvV',
  CustomFilterOptionByTag:
    'https://help.boostcommerce.net/article/283-how-to-create-custom-filter-options-by-tag',
  LocationByInventory:
    'https://help.boostcommerce.net/article/718-how-to-create-a-filter-option-by-inventory-locations',
  DisplaySwatchInFilter: 'https://help.boostcommerce.net/article/281-how-to-display-swatches',
  ManualSortFilterOption:
    'https://help.boostcommerce.net/article/300-how-to-manually-sort-filter-values',
  EditTermSuggestionDictionary:
    'https://help.boostcommerce.net/article/309-how-to-change-the-orders-of-popular-suggestions-using-suggestion-dictionary',
  ExportSuggestionDictionary:
    'https://help.boostcommerce.net/article/310-how-to-export-the-suggestion-dictionary',
  EditRedirect: 'https://help.boostcommerce.net/article/315-how-to-use-redirect',
  ExportRedirects: 'https://help.boostcommerce.net/article/316-how-to-export-redirects',
  OptionTypeSwatchDoc: 'https://help.boostcommerce.net/article/281-how-to-display-swatches',
  SetupAppOnCertainTheme:
    'https://help.boostcommerce.net/article/343-how-to-set-up-the-app-on-a-certain-theme',
  ExportStopWords:
    'https://www.notion.so/boostcommerce/How-to-export-stop-words-e8d08e82cf994cffaf4893ecc353f90e',
  EditSynonyms: 'https://help.boostcommerce.net/article/409-how-to-use-synonyms',
  ManualSynonymGuide:
    'https://support.boostcommerce.net/en/articles/9359386-how-to-enable-synonym-search',
  ExportSynonyms:
    'https://support.boostcommerce.net/en/articles/9359386-how-to-enable-synonym-searching#h3)',
  ProductRankingDoc: 'https://help.boostcommerce.net/article/411-how-to-use-product-ranking',
  MerchandisingDoc: 'https://help.boostcommerce.net/article/412-how-to-use-merchandising',
  MerchandisingDocV2:
    'https://support.boostcommerce.net/en/articles/9362095-visual-merchandising-overview',
  MerchandisingDocOverview:
    'https://help.boostcommerce.net/category/838-merchandising-visual-merchandising',
  MerchandisingDoc02: 'https://boostcommerce.net/pages/visual-merchandising',
  AnalyticsDoc: 'https://help.boostcommerce.net/article/413-how-to-use-analytics',
  TotalSaleAnalytics:
    'https://help.boostcommerce.net/article/488-how-to-enable-view-orders-permission-for-analytics',
  OrderRevenueTrackingDoc:
    'https://help.boostcommerce.net/article/488-how-to-enable-view-orders-permission-for-analytics',
  SearchByMetafieldDoc:
    'https://support.boostcommerce.net/en/articles/9355700-filtering-products-by-metafield-value#h_38133a90ab',
  AdvancedSearchSettingsDoc:
    'https://help.boostcommerce.net/article/446-how-does-the-minimum-must-match-advanced-settings-work',
  AdvancedFuzzySearchDoc:
    'https://help.boostcommerce.net/article/753-how-to-use-the-fuzzy-search-advanced-settings',
  CustomRangeSliderDoc:
    'https://help.boostcommerce.net/article/462-how-to-create-range-sliders-from-metafields-product-options-or-tags',
  SearchPageDisplayDoc:
    'https://help.boostcommerce.net/article/481-how-to-show-collections-blogs-and-pages-in-search-results',
  NoSearchResultSuggestionDoc:
    'https://help.boostcommerce.net/article/476-how-to-add-suggestions-for-search-terms-returns-no-results',
  // OnboardingArticles1Doc:
  //   'https://help.boostcommerce.net/article/280-how-to-create-and-manage-a-filter?utm_source=BoostPFS&utm_medium=aha_checklist_2&utm_campaign=Onboarding_Exp_2_Q42020&utm_content=create_filter',
  // OnboardingArticles2Doc:
  //   'https://help.boostcommerce.net/article/281-how-to-display-swatches?utm_source=BoostPFS&utm_medium=aha_checklist_2&utm_campaign=Onboarding_Exp_2_Q42020&utm_content=display_swatches',
  // OnboardingArticles3Doc:
  //   'https://help.boostcommerce.net/article/330-installation-and-theme-faqs?utm_source=BoostPFS&utm_medium=aha_checklist_2&utm_campaign=Onboarding_Exp_2_Q42020&utm_content=theme_faqs',
  // // OnboardingArticles1Doc:
  //   'https://help.boostcommerce.net/article/281-how-to-display-swatches?utm_source=BoostPFS&utm_medium=aha_checklist_1&utm_campaign=Onboarding_Exp_1_Q32020',
  // OnboardingArticles2Doc:
  //   'https://help.boostcommerce.net/article/444-how-to-create-filter-option-or-search-by-metafield?utm_source=BoostPFS&utm_medium=aha_checklist_1&utm_campaign=Onboarding_Exp_1_Q32020',
  // OnboardingArticles3Doc:
  //   'https://help.boostcommerce.net/article/462-how-to-create-range-sliders-from-metafields-product-options-or-tags?utm_source=BoostPFS&utm_medium=aha_checklist_1&utm_campaign=Onboarding_Exp_1_Q32020',
  OnboardingArticles_ColorSwatchDoc01:
    'https://help.boostcommerce.net/article/494-how-to-display-swatches-in-a-filter-option-using-swatch-settings?utm_source=BoostPFS&utm_medium=aha_checklist_3A&utm_campaign=Onboarding_Exp_3_Q42020&utm_content=display_swatches',
  OnboardingArticles_ColorSwatchDoc02:
    'https://help.boostcommerce.net/article/494-how-to-display-swatches-in-a-filter-option-using-swatch-settings?utm_source=BoostPFS&utm_medium=aha_checklist_3B&utm_campaign=Onboarding_Exp_3_Q42020&utm_content=Day0',
  OnboardingArticles_InstantSearchDoc:
    'https://help.boostcommerce.net/category/592-search-instant-search-display?utm_source=BoostPFS&utm_medium=aha_checklist_3A&utm_campaign=Onboarding_Exp_3_Q42020&utm_content=instant_search',
  OnboardingArticles_SuggestionDoc:
    'https://help.boostcommerce.net/article/309-how-to-change-the-orders-of-popular-suggestions-using-suggestion-dictionary?utm_source=BoostPFS&utm_medium=aha_checklist_3A&utm_campaign=Onboarding_Exp_3_Q42020&utm_content=suggestion_dict',
  OnboardingArticles_SearchFieldDoc:
    'https://help.boostcommerce.net/article/311-how-to-use-search-fields?utm_source=BoostPFS&utm_medium=aha_checklist_3B&utm_campaign=Onboarding_Exp_3_Q42020&utm_content=Day0',
  OnboardingArticles_SearchByMetafieldDoc:
    'https://support.boostcommerce.net/en/articles/9355700-filtering-products-by-metafield-value#h_38133a90ab',
  OnboardingArticles_StopWordDoc:
    'https://help.boostcommerce.net/article/410-how-to-use-stop-words?utm_source=BoostPFS&utm_medium=aha_checklist_3C&utm_campaign=Onboarding_Exp_3_Q42020&utm_content=Day0',
  OnboardingArticles_FilterDoc:
    'https://help.boostcommerce.net/article/280-how-to-create-filter-options-by-product-options-vendor-product-type?utm_source=BoostPFS&utm_medium=aha_checklist_3C&utm_campaign=Onboarding_Exp_3_Q42020&utm_content=Day0',
  OnboardingArticlesGuideDoc:
    'https://help.boostcommerce.net/article/340-app-onboarding#a4?utm_source=BoostPFS&utm_medium=aha_checklist_1&utm_campaign=Onboarding_Exp_1_Q32020',
  SearchTrialDoc:
    'https://help.boostcommerce.net/article/437-what-happens-after-my-trial?utm_source=BoostPFS&utm_medium=in_app_notification&utm_campaign=Onboarding_Exp_2_Q42020',
  LandingPage: {
    Y2020Q4: {
      Doc1: 'https://help.boostcommerce.net/article/453-how-to-create-a-multi-level-tags-filter-option',
      Doc2: 'https://help.boostcommerce.net/article/476-how-to-add-suggestions-for-search-terms-returns-no-results',
      Doc3: 'https://support.boostcommerce.net/en/articles/9359978-shopify-multi-currency-integration-guide',
      Doc4: 'https://help.boostcommerce.net/article/413-how-to-use-analytics',
      Doc5: 'https://help.boostcommerce.net/article/488-how-to-enable-view-orders-permission-for-analytics',
      Doc6: 'https://boostcommerce.net/blogs/all/boost-filter-search-optimization-for-shopify-stores-site-speed?_pos=1&_sid=92aee8c37&_ss=r',
      Doc7: 'https://help.boostcommerce.net/article/494-how-to-display-swatches-in-a-filter-option-using-swatch-settings',
      Doc8: 'https://support.boostcommerce.net/en/collections/9468782-sort-by-options',
      Doc9: 'https://support.boostcommerce.net/en/collections/9461876-third-party-app-integration'
    }
  },
  ReferralBenefit:
    'https://boostcommerce.net/pages/affiliate-program?utm_source=inapp&utm_medium=devstores&utm_campaign=AffiliatePromotion',
  OfficialLaunch23: 'https://bit.ly/409yVfY',
  PublishThemeDoc:
    'https://help.shopify.com/en/manual/online-store/os/using-themes/managing-themes/publishing-themes#publish-a-theme-from-the-admin',
  FilterOptionBestPractice:
    'https://help.boostcommerce.net/article/495-create-filter-tree-best-practice',
  SyncDoc: 'https://support.boostcommerce.net/en/articles/9393595-how-to-use-the-sync-features',
  SyncSettingDoc:
    'https://support.boostcommerce.net/en/articles/9393595-how-to-use-the-sync-features#h_9176f38c12',
  SyncDocBoostAllCollection:
    'https://support.boostcommerce.net/en/articles/9393595-how-to-use-the-sync-features#new5',
  GlobalSellingGuide:
    'https://support.boostcommerce.net/en/articles/10353291-global-selling-for-shopify-markets',
  WholesaleSellingGuide:
    'https://support.boostcommerce.net/en/articles/10353225-wholesale-selling-for-shopify-b2b',
  PresentmentPricesNotUpdated:
    'https://community.shopify.com/c/Shopify-APIs-SDKs/Presentment-prices-not-updated-in-products-REST-endpoint-after/m-p/1078694',
  MultipleCurrenciesLimitation:
    'https://shopify.dev/tutorials/support-different-pricing-models-with-the-price-list-api#current-limitations',
  CustomSortingTranslationDoc:
    'https://help.boostcommerce.net/article/507-how-to-translate-the-label-of-a-sort-by-option',
  AffiliateProgramDoc:
    'https://boostcommerce.net/pages/affiliate-program?utm_source=BoostPFS&utm_medium=in-app+popup&utm_campaign=AffiliatePromotion',
  FreeThemesDoc: 'https://help.boostcommerce.net/article/342-supported-theme',
  FilterLayoutSettingsDoc: 'https://help.boostcommerce.net/article/726-how-to-change-filter-layout',
  SupportedThemeDoc: 'https://help.boostcommerce.net/article/342-supported-theme',
  DefaultThemeDoc: 'https://help.boostcommerce.net/article/337-default-theme#a1',
  DefaultThemeSettingsAspectRatio:
    'https://help.shopify.com/en/manual/shopify-admin/productivity-tools/image-editor#image-aspect-ratio',
  DefaultThemeSettingsCustomLabelByTag:
    'https://help.boostcommerce.net/article/475-how-to-create-custom-label-by-tag-in-the-default-theme',
  RecommendedAppsLink: 'https://boostcommerce.net/pages/integration',
  ChangeLogs: 'https://updates.boostcommerce.net/',
  ChangeLogsV2: 'https://updates.boostcommerce.net/', //'https://apphub-sites.webflow.io/apps/boost/updates',
  Blogs: 'https://boostcommerce.net/blogs/all',
  // Tutorial videos
  ThemeSetupTut: 'https://www.youtube.com/embed/X2lms1SVwUY?start=35',
  ThemeRevertTut: 'https://www.youtube.com/embed/X2lms1SVwUY?start=123',
  SwitchFilterLayoutTut: 'https://www.youtube.com/embed/-mh3vXjGziI?start=123',
  // DefaultLayoutSettingsTut: 'https://www.youtube.com/embed/-mh3vXjGziI?start=167',
  DefaultThemeSettingsTut: 'https://www.youtube.com/embed/3oRZI-vj9WI',
  SynonymsTut: 'https://www.youtube.com/embed/M8ZlQboVPzM',
  RedirectsTut: 'https://www.youtube.com/embed/Hq4md9-ubsY',
  StopWordsTut: 'https://www.youtube.com/embed/2sAdUN2ESKc',
  ShopifyRatingPage:
    'https://apps.shopify.com/product-filter-search?utm_source=BoostPFS&utm_medium=ReviewBlock&utm_campaign=Shopify%20Review%20Test%202#modal-show=ReviewListingModal',
  InstantSearchDisplayTut: 'https://www.youtube.com/embed/R1kH5HZbtjA',
  PlaylistTut: 'https://www.youtube.com/@BoostCommerce/playlists',
  InstantSearchDisplay_LayoutSettingsTut: 'https://www.youtube.com/embed/R1kH5HZbtjA?start=29',
  InstantSearchDisplay_DisplaySettingsTut: 'https://www.youtube.com/embed/R1kH5HZbtjA?start=74',
  SearchPageDisplayTut: 'https://www.youtube.com/embed/Jfqc45msJbE?start=235',
  SearchFeatureTut: 'https://www.youtube.com/embed/Jfqc45msJbE?t=4',
  SuggestionDictionaryTut: 'https://www.youtube.com/embed/Jfqc45msJbE?start=279',
  SearchSettingsTut: 'https://www.youtube.com/embed/Jfqc45msJbE?start=37',
  FilterTreeTut: 'https://www.youtube.com/embed/M6g5ufDjJls',
  FilterSettingsTut: 'https://www.youtube.com/embed/2fYbVA7nlLA',
  FilterBasicTut: 'https://www.youtube.com/embed/M6g5ufDjJls?t=4',
  MergeValuesTut: 'https://www.youtube.com/embed/ibjHv9vv0P0',
  ProductVisibilityTut: 'https://www.youtube.com/embed/Twf29U60rc8',
  ProductRankingTut: 'https://www.youtube.com/embed/nBjQ80pQB0Q?start=47',
  MerchandisingTut: 'https://www.youtube.com/embed/vUYeSvTcKe4',
  AnalyticsTut: 'https://www.youtube.com/embed/qNGFEpft3gY',
  CustomRangeSliderTut: 'https://www.youtube.com/embed/0Bd-Ghkqde8',
  QuickViewCartSettingsTut: 'https://www.youtube.com/embed/z9qhR-J11fw',
  ShopifyIntegrationTut: 'https://www.youtube.com/embed/NPwoslidyBs?si=dtmoC1Flzw0styMi',
  // recommendation
  RecommendationWidgetsDoc:
    'https://help.boostcommerce.net/category/819-recommendation-beta-feature',
  RecommendationWidgetsAbout:
    'https://support.boostcommerce.net/en/articles/9400263-basic-flow-to-set-up-a-boost-recommendation-widget',
  RecommendationWidgetsCheckout:
    'https://support.boostcommerce.net/en/articles/11823036-how-to-set-up-recommendation-widget-for-checkout-page',
  RecommendationRuleBasedLearnmore:
    'https://support.boostcommerce.net/en/articles/9362129-setting-up-rule-based-recommendation',
  RecommendationWidgetsReplace:
    'https://support.boostcommerce.net/en/articles/9362185-how-to-customize-recommendation-widgets-on-a-theme#h11',
  RecommendationManualDoc:
    'https://support.boostcommerce.net/en/articles/9362176-how-to-set-up-hand-picked-products-recommendation',
  RecommendationFeatureSetupManually:
    'https://help.boostcommerce.net/article/882-how-to-setup-recommendation-feature-manually-for-os-2-0-os-1-0',
  RecommendationBestPractice:
    'https://help.boostcommerce.net/category/830-recommendation-recommendation-best-practice',
  RecommendationTutorialVideo: 'https://www.youtube.com/watch?v=3044K3ay-D4&t=242s',
  RecommendationHandPickedSettingsLearnMore:
    'https://support.boostcommerce.net/en/articles/9362176-how-to-set-up-hand-picked-products-recommendation',
  RecommendationBestSellersSettingsLearnMore:
    'https://support.boostcommerce.net/en/articles/9400263-basic-flow-to-set-up-a-boost-recommendation-widget#h_90475d257a',
  // AB - Testing
  ABTestingUserGuide:
    'https://support.boostcommerce.net/en/articles/11507405-a-b-testing-for-merchandising',
  EnableQuickViewDoc: 'https://help.boostcommerce.net/article/867-enabling-quick-view',
  CustomLabelByTagDoc: 'https://help.boostcommerce.net/article/858-customizing-custom-label-by-tag',
  SwatchItemDoc: 'https://help.boostcommerce.net/article/865-customizing-swatch-item-element',
  CustomizingProductItemSection:
    'https://help.boostcommerce.net/article/854-customizing-product-item-section',
  OnboardingThemeSetupTAE: 'https://shopify.dev/docs/apps/online-store/theme-app-extensions',
  OnboardingThemeSetupGuide:
    'https://help.boostcommerce.net/article/679-how-to-enable-app-blocks-in-theme-app-extension',

  Link_V2_Sync_ManualGuide:
    'https://support.boostcommerce.net/en/articles/9393595-how-to-use-the-sync-features',

  Link_V2_Analytics_ManualGuide:
    'https://support.boostcommerce.net/en/articles/9362211-boost-ai-search-discovery-analytics',
  Link_V2_Analytics_PreOrder_ManualGuide:
    'https://support.boostcommerce.net/en/articles/10248032-pre-order-analytics',
  Link_V2_Analytics_AppImpact_ManualGuide:
    'https://support.boostcommerce.net/en/articles/9362215-getting-app-impact-analytics',
  Link_V2_Analytics_Search_ManualGuide:
    'https://support.boostcommerce.net/en/articles/9362218-getting-search-analytics',
  Link_V2_Analytics_Collection_ManualGuide:
    'https://support.boostcommerce.net/en/articles/9362222-getting-collection-analytics',
  Link_V2_Analytics_Recommend_ManualGuide:
    'https://support.boostcommerce.net/en/articles/9362227-getting-recommendation-analytics',
  Link_V2_Analytics_Settings_ManualGuide:
    'https://support.boostcommerce.net/en/articles/9362211-boost-ai-search-discovery-analytics',
  Link_V2_Analytics_PostPurchase_ManualGuide:
    'https://support.boostcommerce.net/en/articles/15773393-getting-post-purchase-offer-analytics',
  // Link_V2_Analytics_Video: 'https://www.youtube.com/watch?time_continue=1&v=qNGFEpft3gY&embeds_euri=https%3A%2F%2Fbc-sf-filter-admin-html-v2.mybcapps.com%2F&feature=emb_logo&ab_channel=BoostCommerce',
  Link_V2_Analytics_Video: 'https://www.youtube.com/embed/qNGFEpft3gY',

  Link_V2_Filter_ManageFilterTree_ManualGuide:
    'https://support.boostcommerce.net/en/collections/9437027-manage-filter-trees',
  Link_V2_FilterTrees_Guide: 'https://help.boostcommerce.net/article/776-filter-trees',
  // Link_V2_Filter_ManageFilterTree_Video: 'https://www.youtube.com/watch?v=M6g5ufDjJls&t=4s&ab_channel=BoostCommerce',
  Link_V2_Filter_ManageFilterTree_Video: 'https://www.youtube.com/embed/M6g5ufDjJls?start=4',

  Link_V2_Filter_FilterLayout_ManualGuide:
    'https://support.boostcommerce.net/article/726-how-to-change-filter-layout',

  Link_V2_Filter_FilterSetting_ManualGuide:
    'https://support.boostcommerce.net/en/collections/9437029-filter-settings',
  // Link_V2_Filter_FilterSetting_Video: 'https://www.youtube.com/watch?v=2fYbVA7nlLA&t=1s',
  Link_V2_Filter_FilterSetting_Video: 'https://www.youtube.com/embed/2fYbVA7nlLA?start=5',

  Link_V2_Filter_MergeValue_ManualGuide:
    'https://support.boostcommerce.net/en/articles/9359373-how-to-merge-values',
  // Link_V2_Filter_MergeValue_Video: 'https://www.youtube.com/watch?v=ibjHv9vv0P0',
  Link_V2_Filter_MergeValue_Video: 'https://www.youtube.com/embed/ibjHv9vv0P0?start=5',

  Link_V2_Filter_CustomRangeSlider_ManualGuide:
    'https://support.boostcommerce.net/en/articles/9355699-filtering-products-by-using-range-sliders',
  // Link_V2_Filter_CustomRangeSlider_Video: 'https://www.youtube.com/watch?v=0Bd-Ghkqde8',
  Link_V2_Filter_CustomRangeSlider_Video: 'https://www.youtube.com/embed/0Bd-Ghkqde8?start=5',

  Link_V2_Filter_SwatchSetting_ManualGuide:
    'https://support.boostcommerce.net/en/articles/9355701-displaying-swatches-in-your-filter-tree',

  Link_V2_Search_InstantSearchDisplay_ManualGuide:
    'https://support.boostcommerce.net/en/collections/9465918-instant-search-bar',
  // Link_V2_Search_InstantSearchDisplay_Video: 'https://www.youtube.com/watch?v=R1kH5HZbtjA',
  Link_V2_Search_InstantSearchDisplay_Video: 'https://www.youtube.com/embed/R1kH5HZbtjA',

  Link_V2_Search_SearchPageDisplay_ManualGuide:
    'https://support.boostcommerce.net/en/articles/9360403-how-to-customize-the-display-of-your-search-results-pages',
  Link_V2_In_Collection_Search_Guide:
    'https://support.boostcommerce.net/en/articles/9360396-how-to-enable-the-in-collection-search',

  Link_V2_Search_SearchPageDisplay_Video: 'https://www.youtube.com/embed/Jfqc45msJbE?start=235',

  Link_V2_Search_SuggestionDictionary_ManualGuide:
    'https://support.boostcommerce.net/en/articles/9360394-custom-ranking-of-popular-suggestions-returned-by-autocomplete-search',
  // Link_V2_Search_SuggestionDictionary_Video: 'https://www.youtube.com/watch?v=Jfqc45msJbE&t=279s',
  Link_V2_Search_SuggestionDictionary_Video: 'https://www.youtube.com/embed/Jfqc45msJbE?start=279',

  Link_V1_Search_SearchSetting_ManualGuide:
    'https://help.boostcommerce.net/article/797-the-algorithm-of-our-site-search-features',
  Link_V2_Search_SearchSetting_ManualGuide:
    'https://support.boostcommerce.net/en/articles/9359406-the-algorithm-of-search-relevance',

  Link_V1_Search_Synonym_ManualGuide:
    'https://support.boostcommerce.net/en/articles/9359386-how-to-enable-synonym-search',
  Link_V2_Search_Synonym_ManualGuide:
    'https://support.boostcommerce.net/en/articles/9360371-how-to-enable-ai-synonym-search',
  Link_Search_Semantic_ManualGuide:
    'https://support.boostcommerce.net/en/articles/9360380-semantic-search',

  Link_Search_Product_Performance_Ranking_Guide:
    'https://support.boostcommerce.net/en/articles/9360384-product-performance-ranking',
  Link_V2_Search_StopWords_ManualGuide:
    'https://support.boostcommerce.net/en/articles/9360399-how-to-apply-stop-words-to-the-search-bar',
  // Link_V2_Search_StopWords_Video: 'https://www.youtube.com/watch?v=2sAdUN2ESKc',
  Link_V2_Search_StopWords_Video: 'https://www.youtube.com/embed/2sAdUN2ESKc',

  Link_V2_Search_Redirects_ManualGuide:
    'https://support.boostcommerce.net/en/articles/9360409-how-to-set-up-redirects',
  // Link_V2_Search_Redirects_Video: 'https://www.youtube.com/watch?v=Hq4md9-ubsY',
  Link_V2_Search_Redirects_Video: 'https://www.youtube.com/embed/Hq4md9-ubsY',

  Link_V2_AI_Search_Doc: 'https://help.boostcommerce.net/category/590-search',

  Link_Test_Your_Search_Guide:
    'https://support.boostcommerce.net/en/articles/9360386-test-your-search',
  Link_Test_Your_Search_Video: 'https://www.youtube.com/embed/beuJ3RtH7SQ?si=dLh_NqUF9TKu1MTx',

  Link_V2_Merchandising_ProductRanking_ManualGuide:
    'https://help.boostcommerce.net/article/812-ranking-specific-products-in-search-results',
  // Link_V2_Merchandising_ProductRanking_Video: 'https://www.youtube.com/watch?v=nBjQ80pQB0Q&t=47s',
  Link_V2_Merchandising_ProductRanking_Video: 'https://www.youtube.com/embed/nBjQ80pQB0Q?start=47',

  Link_Search_Personalization_Guide:
    'https://support.boostcommerce.net/en/articles/9360388-search-personalization',
  Link_Personalization_Guide:
    'https://blog.boostcommerce.net/posts/boosts-ai-powered-personalization?&utm_source=in-app&utm_medium=register-successfull-popup&utm_campaign=BoostPer60',
  Link_V2_Merchandising_RuleBaseMerchandising_ManualGuide:
    'https://help.boostcommerce.net/article/813-ranking-a-group-of-products-in-search-results',
  // Link_V2_Merchandising_RuleBaseMerchandising_Video: 'https://www.youtube.com/watch?v=nBjQ80pQB0Q&t=241s',
  Link_V2_Merchandising_RuleBaseMerchandising_Video:
    'https://www.youtube.com/embed/nBjQ80pQB0Q?start=241',

  Link_V2_Merchandising_ProductVisibility_ManualGuide:
    'https://help.boostcommerce.net/article/814-bulk-hiding-products-from-collection-pages-and-search-results',
  // Link_V2_Merchandising_ProductVisibility_Video: 'https://www.youtube.com/watch?v=Twf29U60rc8',
  Link_V2_Merchandising_ProductVisibility_Video: 'https://www.youtube.com/embed/Twf29U60rc8',

  Link_V2_Merchandising_MerchandisingV2_ManualGuide:
    'https://support.boostcommerce.net/en/articles/9362095-visual-merchandising-overview',
  Link_Manage_Your_Template_Product_List:
    'https://support.boostcommerce.net/en/articles/9393583-manage-your-template-product-list',
  Link_V2_Theme_ThemeSetup_ManualGuide:
    'https://support.boostcommerce.net/en/collections/9468770-theme-setup-for-turbo-version',
  Link_V2_Theme_ThemeSetup_ManualGuide_FormerVersion:
    'https://support.boostcommerce.net/en/collections/9468767-general-theme-setup',
  Link_V2_Theme_QuickViewAndCart_ManualGuide:
    'https://help.boostcommerce.net/article/736-how-to-use-quick-view-cart-settings',
  // Link_V2_Theme_QuickViewAndCart_Video: 'https://www.youtube.com/watch?v=z9qhR-J11fw',
  Link_V2_Theme_QuickViewAndCart_Video: 'https://www.youtube.com/embed/z9qhR-J11fw',

  Link_V2_Theme_DefaultTheme_ManualGuide:
    'https://help.boostcommerce.net/article/737-how-to-use-the-default-theme-settings',
  // Link_V2_Theme_DefaultTheme_Video: 'https://www.youtube.com/watch?v=3oRZI-vj9WI&t=1s',
  Link_V2_Theme_DefaultTheme_Video: 'https://www.youtube.com/embed/3oRZI-vj9WI?start=1',

  Link_V2_Tool_Translation_ManualGuide:
    'https://help.boostcommerce.net/category/634-tool-translation',

  Link_V2_Tool_Integration_ManualGuide:
    'https://support.boostcommerce.net/en/collections/9461876-third-party-app-integration',

  Link_V2_Tool_Metafield_ManualGuide:
    'https://help.boostcommerce.net/article/784-filtering-products-by-metafield-value',

  Link_V2_Tool_SortByOption_ManualGuide:
    'https://support.boostcommerce.net/en/collections/9468782-sort-by-options',
  Link_V1_Tool_VariantDisplay_ManualGuide:
    'https://help.boostcommerce.net/article/741-how-to-use-variants-display',
  Link_V2_Tool_VariantDisplay_ManualGuide:
    'https://support.boostcommerce.net/en/articles/9393636-how-to-enable-variants-display',
  Link_V2_Tool_VariantDisplay_Doc:
    'https://boostcommerce.net/blogs/all/introducing-variants-display',

  Link_V2_Tool_LanguageSetting_ManualGuide:
    'https://support.boostcommerce.net/en/articles/9393631-how-to-change-language-in-boost-ai-search-discovery',

  Link_V2_Recommendation_ManageWidget_ManualGuide:
    'https://support.boostcommerce.net/en/collections/9436966-recommendation',
  Link_V2_Recommendation_ManageWidget_Video:
    'https://www.youtube.com/embed/VVNC3HbrAYQ?si=a0YV31fy4lldiUXI',
  Link_V2_Recommendation_ManageWidget_BestPractice:
    'https://support.boostcommerce.net/en/articles/9362112-product-recommendation-best-practices-guide',

  Link_V2_Recommendation_GeneralSettings_ManualGuide:
    'https://support.boostcommerce.net/en/articles/9362206-recommendation-general-settings',
  Link_V2_Recommendation_GeneralSettings_BestPractice:
    'https://support.boostcommerce.net/en/articles/9362112-product-recommendation-best-practices-guide',
  Link_V2_Semantic_Search_For_Shopify:
    'https://blog.boostcommerce.net/posts/semantic-search-for-shopify-ecommerce-101',
  Link_V2_Recommendation_ManualSetting_ManualGuide:
    'https://support.boostcommerce.net/en/articles/9362176-how-to-set-up-hand-picked-products-recommendation',
  Link_V2_Recommendation_ManualSetting_BestPractice:
    'https://support.boostcommerce.net/en/articles/9362112-product-recommendation-best-practices-guide',
  Link_V2_Recommendation_PredictiveBundle_ManualGuide:
    'https://support.boostcommerce.net/en/articles/9629727-how-to-create-a-bundle',
  // App integration link
  Banner_Campaign_AppHub:
    'https://boostcommerce.net/blogs/all/boost-commerce-is-now-a-part-of-the-apphub-family?&utm_source=inapp&utm_medium=banner&utm_campaign=apphub-acquisition',
  Banner_Campaign_Recommended_App_Link:
    'https://apps.shopify.com/reviews-co-uk-product-and-merchant-review-collection?utm_source=boost&utm_medium=in-app&utm_content=top-banner&utm_campaign=new_installs',
  Analytic_help_guide:
    'https://help.boostcommerce.net/article/916-how-to-customize-analytics-for-boost-v2',
  AI_Powered_Search: 'https://support.boostcommerce.net/en/articles/9360375-ai-powered-search',
  Search_Site_Search_Algorithm:
    'https://support.boostcommerce.net/en/articles/9360382-search-engine-control',
  Search_Control_Search_Field:
    'https://support.boostcommerce.net/en/articles/9359406-the-algorithm-of-search-relevance#h1',
  Search_Control_Partial_Search: 'https://help.boostcommerce.net/article/835-partial-search',
  Search_Control_Typo: 'https://help.boostcommerce.net/article/836-typo-tolerance',
  Search_Control_Special_Character:
    'https://help.boostcommerce.net/article/837-numeric-search-and-special-character',
  Search_Control_Merchandising:
    'https://help.boostcommerce.net/article/840-merchandising-rules-for-commerce-search',
  YearEndReview2023:
    'https://boostcommerce.net/pages/2023-in-retrospect?utm_source=inapp&utm_medium=popup&utm_campaign=yer-2023',
  ProductImageThemeSetting:
    'https://help.boostcommerce.net/article/855-customizing-product-image-section',
  ProductImageAreaThemeSetting:
    'https://help.boostcommerce.net/article/855-customizing-product-image-section#:~:text=item > Product image-,Product Image section general,-Product Image section',
  SaleLabelThemeSetting: 'https://help.boostcommerce.net/article/856-customizing-sale-label',
  SoldOutLabelThemeSetting: 'https://help.boostcommerce.net/article/857-customizing-sold-out-label',
  ProductInformationThemeSetting:
    'https://help.boostcommerce.net/article/859-customizing-product-information-section',
  ProductTitleThemeSetting:
    'https://help.boostcommerce.net/article/860-customizing-product-title-element',
  ProductVendorThemeSetting:
    'https://help.boostcommerce.net/article/861-customizing-product-vendor-element',
  ProductPriceThemeSetting:
    'https://help.boostcommerce.net/article/863-customizing-product-price-element',
  InventoryStatusThemeSetting:
    'https://help.boostcommerce.net/article/864-customizing-inventory-status-element',
  ProductRatingThemeSetting:
    'https://help.boostcommerce.net/article/862-customizing-product-rating-element-beta-feature',
  NormalSwatchThemeSetting:
    'https://help.boostcommerce.net/article/865-customizing-swatch-item-element',
  ProductButtonThemeSetting:
    'https://help.boostcommerce.net/article/866-customizing-call-to-action-element',
  QuickViewThemeSetting: 'https://help.boostcommerce.net/article/867-enabling-quick-view',
  AjaxCartThemeSetting: 'https://help.boostcommerce.net/article/869-customizing-ajax-cart',
  CollectionHeaderThemeSetting:
    'https://help.boostcommerce.net/article/848-customizing-the-style-of-page-header#Collection-Header-1CtLq:~:text=Collection header.-,Collection Header,-Layout library',
  CollectionImageThemeSetting:
    'https://help.boostcommerce.net/article/848-customizing-the-style-of-page-header#Collection-Header-1CtLq:~:text=you have made-,Collection Image,-The Collection',
  CollectionTitleThemeSetting:
    'https://help.boostcommerce.net/article/848-customizing-the-style-of-page-header#Collection-Header-1CtLq:~:text=you have made.-,Collection Title,-The Collection',
  CollectionDescriptionThemeSetting:
    'https://help.boostcommerce.net/article/848-customizing-the-style-of-page-header#Collection-Header-1CtLq:~:text=you have made-,Collection Description,-The Collection',
  CollectionBreadcrumbThemeSetting:
    'https://help.boostcommerce.net/article/848-customizing-the-style-of-page-header#Collection-Header-1CtLq:~:text=you have made.-,Breadcrumbs,-You can add',
  CollectionProductCountThemeSetting:
    'https://help.boostcommerce.net/article/850-customizing-product-count-element#:~:text=In Collection header %2C you can choose the Text description for the Product count on your pages. there are 2 options%3A',
  ToolbarThemeSetting: 'https://help.boostcommerce.net/article/849-customizing-toolbar-section',
  ToolbarViewAsThemeSetting:
    'https://help.boostcommerce.net/article/849-customizing-toolbar-section#:~:text=Toolbar%20elements%2C%20including%3A-,View%20as%20element,-On%20the%20right',
  ToolBarProductCountThemeSetting:
    'https://help.boostcommerce.net/article/849-customizing-toolbar-section#:~:text=you have made-,Product count element,-On the Right',
  ProductListThemeSetting:
    'https://help.boostcommerce.net/article/852-customizing-product-list-section',
  PaginationThemeSetting: 'https://help.boostcommerce.net/article/853-enabling-pagination',
  InventoryStatusSetting:
    'https://support.boostcommerce.net/en/articles/9393182-how-to-customize-the-inventory-status-element',

  BoostTemplateWidgets:
    'https://support.boostcommerce.net/en/articles/9362430-introduction-to-boost-templates-widgets',
  ShopifyIntegrationSettingsColor:
    'https://support.boostcommerce.net/en/articles/9393247-manage-your-template-style-settings#h_005525e63f',
  ShopifyIntegrationSettingsCodeEditor:
    'https://help.boostcommerce.net/article/953-manage-your-template-code-editor',
  ShopifyIntegrationSettingsColorPaletteGuide:
    'https://help.boostcommerce.net/article/951-manage-your-template-style-settings#Base-colors-CEaQs',
  ShopifyIntegrationSmartStyling:
    'https://support.boostcommerce.net/en/articles/9954902-manage-your-template-smart-styling',
  AddOn_Search: 'https://support.boostcommerce.net/en/articles/9360375-ai-powered-search',
  AddOn_Merchandising:
    'https://support.boostcommerce.net/en/articles/9362101-merchandising-rules-for-collection-page',
  AddOn_Recommend:
    'https://support.boostcommerce.net/en/articles/9362152-setting-up-ai-based-recommendation',
  AddOn_Analytic:
    'https://support.boostcommerce.net/en/articles/9362211-boost-ai-search-discovery-analytics',
  AddOn_Variant:
    'https://support.boostcommerce.net/en/articles/9393636-how-to-enable-variants-display',
  SetupWidgetForTheme:
    'https://support.boostcommerce.net/en/collections/9468770-theme-setup-for-turbo-version',
  RemoveWidgetForTheme:
    'https://support.boostcommerce.net/en/articles/9362480-uninstall-boost-ai-search-discovery-from-your-store#h_5cbb2d76de',
  AppVersion_Upgrade_Success: 'https://www.youtube.com/embed/HKwjYsa342w?si=hIO7M_RountMEmay',
  NewVersionTurbo:
    'https://boostcommerce.net/blogs/all/feature-release-meet-turbo-for-optimized-storefront-performance',
  BoostTurbo:
    'https://blog.boostcommerce.net/posts/boost-turbo-conversion-rate-optimization-platform',
  HowToUpgradeTurbo:
    'https://support.boostcommerce.net/en/articles/9334531-how-to-switch-versions-in-boost-ai-search-discovery',
  AppVersion_Upgrade_Video: 'https://youtu.be/HKwjYsa342w?si=Yl_oURcEpV2OMc82',
  FreeTrial:
    'https://support.boostcommerce.net/en/articles/12545665-free-trial-gmv-based-subscription#h_0a8a4b1466',
  EnhancedVisualEditor:
    'https://help.boostcommerce.net/category/952-shopify-integration-theme-settings-theme-settings-for-ssr-version',
  PreDesignTemplate:
    'https://support.boostcommerce.net/en/articles/9393245-how-to-customize-your-template',
  B2BIntegration: 'https://help.boostcommerce.net/article/959-sync-b2b-feature',

  ProductListShopifyIntegration:
    'https://support.boostcommerce.net/en/articles/9393583-manage-your-template-product-list',
  ProductListLayoutShopifyIntegration:
    'https://support.boostcommerce.net/en/articles/9393583-manage-your-template-product-list#h_cfa79bf17a',
  ProductListHeaderShopifyIntegration:
    'https://support.boostcommerce.net/en/articles/9393583-manage-your-template-product-list#h_46aefeed23',
  ProductListToolbarShopifyIntegration:
    'https://support.boostcommerce.net/en/articles/9393583-manage-your-template-product-list#h_04e648475d',
  ProductListPaginationShopifyIntegration:
    'https://support.boostcommerce.net/en/articles/9393583-manage-your-template-product-list#h_61c204cd9d',
  ProductItemLayoutShopifyIntegration:
    'https://support.boostcommerce.net/en/articles/9393587-manage-your-template-product-item#h_8ec5787899',
  ProductItemLabelShopifyIntegration:
    'https://support.boostcommerce.net/en/articles/9393587-manage-your-template-product-item#h_a409e7bcf4',
  ProductItemPriceShopifyIntegration:
    'https://help.boostcommerce.net/article/960-manage-your-template-product-item?preview=664efde2f0fdf93e4cf08650#Product-price-zFcA6:~:text=g.%2020%25)-,Product%20price,-Product%20Price%20is',
  ProductItemSwatchesShopifyIntegration:
    'https://help.boostcommerce.net/article/960-manage-your-template-product-item?preview=664efde2f0fdf93e4cf08650#Swatches-INALc:~:text=with%20different%20prices.-,Swatches,-Swatches%20are%20a',
  ProductItemCTAShopifyIntegration:
    'https://help.boostcommerce.net/article/960-manage-your-template-product-item?preview=664efde2f0fdf93e4cf08650#Swatches-INALc:~:text=you%20have%20made.-,Call%20to%20action,-The%20Button%20element',
  ManageTemplateGuide:
    'https://help.boostcommerce.net/article/947-how-to-select-manage-widget-templates-in-boost-ai-search-discovery',
  BoostAppReview:
    'https://apps.shopify.com/product-filter-search?search_id=dae53d48-c51c-4ad6-8c71-881ba71ae068&surface_detail=filter&surface_inter_position=1&surface_intra_position=6&surface_type=search',
  ManageTemplateLibrary:
    'https://help.boostcommerce.net/article/947-how-to-select-manage-widget-templates-in-boost-ai-search-discovery#Manage-Templates-in-your-Library-8I7Wv',
  KlaviyoIntegration:
    'https://support.boostcommerce.net/en/articles/9710489-klaviyo-email-marketing-sms',
  KlaviyoHelperGuide:
    'https://help.klaviyo.com/hc/en-us/articles/115003872251#h_01HBBYWCR7VMA1Q70QTGAXQBGR',
  KlaviyoGuidePasteCode:
    'https://intercom.help/apphub-new-2024/en/articles/9710489-klaviyo-email-marketing-sms#h_dbc80c1464',
  KlaviyoReviewGuide:
    'https://support.boostcommerce.net/en/articles/10248074-klaviyo-reviews-integration-guide',
  ReleaseNoteTemplate:
    'https://support.boostcommerce.net/en/articles/9794762-boost-template-release-notes',
  LearnMoreConflictTemplate:
    'https://support.boostcommerce.net/en/articles/9362452-step-1-how-to-select-manage-widget-templates-in-boost-ai-search-discovery#h_3a0511e5f0:~:text=a%20new%20template.-,Update%20template,-To%20access%20Template',
  KlaviyoEventIntegrationOurGuide:
    'https://support.boostcommerce.net/en/articles/9362452-step-1-how-to-select-manage-widget-templates-in-boost-ai-search-discovery#h_3a0511e5f0',
  KlaviyoEventIntegrationBestPractice:
    'https://support.boostcommerce.net/en/articles/9710489-klaviyo-email-marketing-sms#h_1b7e112045',
  PreOrderCampaignGuide:
    'https://support.boostcommerce.net/en/articles/10050875-how-to-use-pre-order-campaigns',
  PreOrderGeneralSettingsGuide:
    'https://support.boostcommerce.net/en/articles/10051024-pre-order-general-settings',
  BackInStockSettingsGuide:
    'https://support.boostcommerce.net/en/articles/10382245-back-in-stock-how-to-set-up-and-manage-notifications',
  BackInStockSubmissionGuide:
    'https://support.boostcommerce.net/en/articles/10382245-back-in-stock-how-to-set-up-and-manage-notifications',
  BackInStockProductSettingsGuide:
    'https://support.boostcommerce.net/en/articles/10382245-back-in-stock-how-to-set-up-and-manage-notifications#:~:text=pre%2Dorder%20products.%E2%80%9D-,Product%20Settings%20for%20Back%20In%20Stock,-Show%20%27Notify%20Me',
  BackInStockButtonSettingsGuide:
    'https://support.boostcommerce.net/en/articles/10382245-back-in-stock-how-to-set-up-and-manage-notifications#h_dad0c45ca2',
  TurboThemeSetupGuide:
    'https://support.boostcommerce.net/en/collections/9468770-theme-setup-for-turbo-version',
  HowToSetupTurboTheme:
    'https://support.boostcommerce.net/en/articles/10383268-how-to-set-up-a-new-theme-with-boost-turbo-supported-themes#h_35fa2b7ac8',
  TurboUpgradeFAQs:
    'https://support.boostcommerce.net/en/articles/10973042-boost-turbo-upgrade-faqs',
  ProductBundling: 'https://boostcommerce.net/platform/product-bundling',
  WhyIntegrations: 'https://partners.boostcommerce.net/integrations',
  WhyVisualEditor:
    'https://support.boostcommerce.net/en/articles/9954902-manage-your-template-smart-styling',
  WhyCodeEditor:
    'https://support.boostcommerce.net/en/articles/9393581-manage-your-template-code-editor',
  HelpfulGuide:
    'https://support.boostcommerce.net/en/collections/9468776-theme-settings-for-turbo-version',
  UpgradeGuide:
    'https://support.boostcommerce.net/en/articles/10383268-how-to-set-up-a-new-theme-with-boost-turbo-supported-themes#h_35fa2b7ac8',
  ReviewsIoIntegration:
    'https://support.boostcommerce.net/en/articles/9570801-reviews-io-integration-guide',
  ReviewsIoIntegrationAttribute:
    'https://support.boostcommerce.net/en/articles/9570801-reviews-io-integration-guide#h_73686dcea6',
  MetafieldsAndMetaobjectsGuide:
    'https://support.boostcommerce.net/en/articles/9355700-filtering-products-by-metafield-value',
  ReviewsIoRatingMerchandising:
    'https://support.boostcommerce.net/en/articles/9570801-reviews-io-integration-guide#h_54218aa764',
  ReviewsIoRatingRecommendation:
    'https://support.boostcommerce.net/en/articles/9570801-reviews-io-integration-guide#h_ba8cf77193',
  BookDemo: 'https://boostcommerce.net/hub/demo',
  ReviewsIoIntegrationStarRatingTemplate:
    'https://support.boostcommerce.net/en/articles/9570801-reviews-io-integration-guide#h_73686dcea6',
  GeneralSwatchSettings:
    'https://support.boostcommerce.net/en/articles/9355701-displaying-swatches-in-your-filter-tree#h_6a6786ecb0',
  TranslationGuideTurbo:
    'https://support.boostcommerce.net/en/articles/12981159-translation-overview-boost-turbo',
  AttentiveIntegration:
    'https://support.boostcommerce.net/en/articles/12379704-attentive-integration-guide',
  GORGIAS_USER_GUIDE:
    'https://support.boostcommerce.net/en/articles/14482215-gorgias-integration-guide',
  PostPurchaseGuide:
    'https://support.boostcommerce.net/en/articles/13712539-create-a-post-purchase-offer-in-boost-ai-search-discovery',
  CountdownTimerGuide:
    'https://support.boostcommerce.net/en/articles/15079750-how-to-set-up-an-inline-countdown-timer',
  ImportExportTemplateGuide:
    'https://support.boostcommerce.net/en/articles/10383250-how-to-manage-boost-templates-in-your-library#h_03d6d0575d',
  ShopifyCombinedListingGuide:
    'https://support.boostcommerce.net/en/articles/14720893-shopify-combined-listings-integration-guide',
  CombinedListingShopifyGuide: 'https://help.shopify.com/en/manual/products/combined-listings-app',
  CommonVisualChangesUpgradeTurboGuide:
    'https://support.boostcommerce.net/en/articles/15514208-common-storefront-visual-changes-after-upgrading-to-turbo',
  GoogleAnalytics4Guide:
    'https://support.boostcommerce.net/en/articles/15706487-google-analytics-4-ga4-integration-guide',
  GoogleAnalytics4OurGuide:
    'https://support.boostcommerce.net/en/articles/9362452-how-to-select-templates-in-boost-ai-search-discovery-unsupported-themes#h_3a0511e5f0',
  CampaignPlannerGuide: 'https://support.boostcommerce.net/en/articles/16814814-schedule-a-sale-with-campaign-planner'
};
